import '~/js/modules/common'
import '~/js/modules/tabs'
import '~/js/modules/simple-dropdown'
import '../../pug/blocks/novelty-slider/novelty-slider'

const productsLinkClickHandler = (e) => {
  const currentLink = e.currentTarget

  const activeItem = document.querySelector(`.js-products-item.active`)
  const activeLink = document.querySelector(`.js-products-link.active`)

  let currentSubitems

  if (window.innerWidth < 1024) {
    if (!currentLink.classList.contains(`active`)) {
      e.preventDefault()

      if (activeItem && activeLink) {
        activeItem.classList.remove(`active`)
        activeLink.classList.remove(`active`)
      }

      const currentItem = currentLink.closest(`.js-products-item`)

      if (currentItem) {
        currentSubitems = currentItem.querySelector(`.js-products-subitems`)

        if (currentSubitems) {
          const currentSubitemsHeight = currentSubitems.scrollHeight

          document.documentElement.style.setProperty(
            `--active-products-sublist-height`,
            `${currentSubitemsHeight}px`
          )
        }

        currentItem.classList.add(`active`)
        currentLink.classList.add(`active`)
      }
    }
  } else {
    if (!currentLink.classList.contains(`active`)) {
      e.preventDefault()

      if (activeLink) {
        activeLink.classList.remove(`active`)
      }

      const activeSubitems = document.querySelector(`.js-products-subitems.active`)
      const activeSublist = document.querySelector(`.js-products-sublist.active`)

      if (activeSubitems && activeSublist) {
        activeSubitems.classList.remove(`active`)
        activeSublist.classList.remove(`active`)
      }

      currentLink.classList.add(`active`)

      const currentSublistId = currentLink.dataset.sublistId
      const currentSublist = document.querySelector(`.js-products-sublist[data-sublist-id="${currentSublistId}"]`)

      if (currentSublist) {
        const productsList = document.querySelector(`.js-products-list`)
        currentSubitems = currentSublist.closest(`.js-products-subitems`)

        const productsListHeight = productsList.scrollHeight

        let currentSublistHeight = currentSublist.scrollHeight

        if (currentSublistHeight < productsListHeight) {
          currentSublistHeight = productsListHeight
        }

        document.documentElement.style.setProperty(
          `--active-products-sublist-height`,
          `${currentSublistHeight}px`
        )

        currentSublist.classList.add(`active`)

        if (currentSubitems) {
          currentSubitems.classList.add(`active`)
        }
      }
    }
  }
  bannerChange();
}

const bannerChange = () => {
  const banner = document.querySelector(".products__banner");
  const tabs = document.querySelectorAll(".products__link");
  if(banner){
    tabs.forEach((el) => {
      if(el.classList.contains("active") && el.dataset.bannerTitle){
        banner.classList.remove("is-active");
        setTimeout(() => {
          banner.querySelector(".products__banner-image").src = el.dataset.bannerImage;
          banner.querySelector(".products__banner-title").innerText = el.dataset.bannerTitle;
          banner.querySelector(".products__banner-link").href = el.dataset.bannerHref;
          banner.classList.add("is-active");
        }, 400)
      }
      else{
        banner.classList.remove("is-active");
      }
    })
  }
}

document.addEventListener(`DOMContentLoaded`, () => {
  const productsList = document.querySelector(`.js-products-list`)

  if (productsList) {
    const productsItems = productsList.querySelectorAll(`.js-products-item`)

    if (productsItems.length) {
      productsItems.forEach(item => {
        const link = item.querySelector(`.js-products-link`)
        if (link) {
          link.addEventListener(`click`, productsLinkClickHandler)
        }
      })
    }
  }
  bannerChange();
  document.addEventListener(`onTabsChanged`, (e) => {
    const { value } = e.detail

    if (value) {
      const currentTab = document.querySelector(`.js-tab[data-value=${value}]`)

      if (currentTab) {
        const activeTab = currentTab.parentElement.querySelector(`.js-tab.active`)

        if (activeTab) {
          activeTab.classList.remove(`active`)
        }

        currentTab.classList.add(`active`)
      }
    }
  })
})
